import { BadgeCheck, LifeBuoy, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow, CountUp } from "@/components/primitives";

const POINTS = [
  { icon: BadgeCheck, label: "Quality" },
  { icon: LifeBuoy, label: "Expert Support" },
  { icon: ShieldCheck, label: "Confidence" },
];

export default function Warranty() {
  return (
    <section
      id="warranty"
      data-testid="warranty-section"
      className="bg-graphite py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 text-center sm:px-10">
        <Reveal className="flex justify-center">
          <Eyebrow index="08">Service Warranty</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <div
            data-testid="warranty-number"
            className="gold-text mx-auto mt-4 font-display text-[42vw] font-black leading-[0.85] tracking-tighter sm:text-[14rem]"
          >
            <CountUp to={6} />
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-2 font-display text-base font-bold uppercase tracking-[0.4em] text-ivory sm:text-lg">
            Months Service Warranty
          </div>
          <p className="mx-auto mt-5 max-w-sm text-sm font-light leading-relaxed text-ivory/60 sm:text-base">
            Confidence that continues after service.
          </p>
        </Reveal>
        <Reveal delay={0.3} className="mt-12 flex flex-wrap items-center justify-center gap-8 sm:gap-14">
          {POINTS.map((p) => (
            <div
              key={p.label}
              data-testid={`warranty-point-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex flex-col items-center gap-3"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-gold/30 text-gold">
                <p.icon size={20} strokeWidth={1.5} />
              </span>
              <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-ivory/70">
                {p.label}
              </span>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
